var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84822 12.8186L7.24592 8.42091C7.50993 8.1569 7.64193 8.0249 7.79415 7.97544C7.92805 7.93193 8.07228 7.93193 8.20617 7.97544C8.35839 8.0249 8.4904 8.15691 8.75441 8.42091L13.1228 12.7893M9.3335 9L11.2459 7.08758C11.5099 6.82357 11.6419 6.69156 11.7942 6.6421C11.928 6.5986 12.0723 6.5986 12.2062 6.6421C12.3584 6.69156 12.4904 6.82357 12.7544 7.08758L14.6668 9M6.66683 5C6.66683 5.73638 6.06988 6.33333 5.3335 6.33333C4.59712 6.33333 4.00016 5.73638 4.00016 5C4.00016 4.26362 4.59712 3.66667 5.3335 3.66667C6.06988 3.66667 6.66683 4.26362 6.66683 5ZM4.5335 13H11.4668C12.5869 13 13.147 13 13.5748 12.782C13.9511 12.5903 14.2571 12.2843 14.4488 11.908C14.6668 11.4802 14.6668 10.9201 14.6668 9.8V4.2C14.6668 3.0799 14.6668 2.51984 14.4488 2.09202C14.2571 1.71569 13.9511 1.40973 13.5748 1.21799C13.147 1 12.5869 1 11.4668 1H4.5335C3.41339 1 2.85334 1 2.42552 1.21799C2.04919 1.40973 1.74323 1.71569 1.55148 2.09202C1.3335 2.51984 1.3335 3.0799 1.3335 4.2V9.8C1.3335 10.9201 1.3335 11.4802 1.55148 11.908C1.74323 12.2843 2.04919 12.5903 2.42552 12.782C2.85334 13 3.41339 13 4.5335 13Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.e67d79a4200380308325d3d99396f584.svg";
export { ForwardRef as ReactComponent };